import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirAutorizacaoPrevia } from './types';

export const INITIAL_STATE: emitirAutorizacaoPrevia = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirAutorizacaoPrevia {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_AUTORIZACAO_PREVIA_REQUEST: {
				break;
			}

			case Types.EMITIR_AUTORIZACAO_PREVIA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_AUTORIZACAO_PREVIA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.EMITIR_AUTORIZACAO_PREVIA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
